import React from "react";
import { FaChevronRight } from "react-icons/fa6";
import { formatToIndianRupees } from "../../../../../utils/handlers";

function InflowTop({ data, inflow }) {
  const calculateTotal = (data) => {
    let total = 0;
    if (!data) return formatToIndianRupees(total);
    data.forEach((item) => {
      total += item.amount;
    });
    return formatToIndianRupees(total);
  };

  return (
    <div className=" w-[49.5%] rounded-lg border border-[#e6ebed] h-[347px]    ">
      <div className=" w-full h-[45px] flex  px-4 justify-between items-center bg-[#f3f3f3] rounded-lg font-bold text-base">
        <p>{inflow ? "Inflow" : "Outflow"}</p>
        <p>{calculateTotal(data)}</p>
      </div>{" "}
      <div className=" w-full h-[45px] flex  px-4 justify-between items-center   font-semibold text-sm border-b border-[#e6ebed]">
        <p>Category</p>
        <p>Amount (₹)</p>
      </div>
      <div className="h-[255px] overflow-auto">
        {data?.map((item, index) => (
          <div
            key={index}
            className={` w-full h-[45px] flex  px-4 justify-between items-center   font-medium text-xs ${
              index !== data.length - 1 ? "border-b border-[#e6ebed]" : ""
            } hover:bg-[#f3f3f3] `}
          >
            <p>{item.category}</p>
            <p className=" flex items-center">
              {formatToIndianRupees(item.amount)}
              <span className=" ml-[10px]">
                <FaChevronRight color="#00394d" />
              </span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InflowTop;
